import { Injectable, computed, signal } from '@angular/core';

import { NA_COUNTRIES, NA_LOCALE, NA_REGION, localeFormats, toSupportedLocale } from '@shared/constants/region-locale';
import { LinxWorkflowRawResponse } from '@shared/models';

@Injectable({ providedIn: 'root' })
export class RegionContextService {
  readonly region = signal(NA_REGION);
  readonly countries = signal<string[]>(NA_COUNTRIES);
  readonly locale = signal(NA_LOCALE);

  readonly formats = computed(() => localeFormats(this.locale()));
  readonly dateFormat = computed(() => this.formats().dateFormat);
  // A region with several countries has no sensible default, and EU must not inherit the US one.
  readonly defaultCountry = computed<string | undefined>(() => (this.countries().length === 1 ? this.countries()[0] : undefined));

  set(response: Pick<LinxWorkflowRawResponse, 'region' | 'countries' | 'locale'>): void {
    this.region.set(response.region || NA_REGION);
    this.countries.set(response.countries?.length ? response.countries.map((code) => code.toUpperCase()) : NA_COUNTRIES);
    this.locale.set(toSupportedLocale(response.locale));
  }
}
